/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import CompactViewNotes from './CompactViewNotes/index'
import CreateFieldAction from './CreateFieldAction/index'
import DataVaxiomTxCardFieldDefinitionsList from 'DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsList/index'
import DefaultView from './DefaultView/index'
import PaymentPlans from './PaymentPlans/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCard/Content/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXxl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxl'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let selectedLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'location_id',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--ml-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Treatment card"
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Choose how you display past appointments — through a compact table or a detailed timeline — and decide whether to show full or shortened notes text, all for a tailored view."
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginBottom={0}
/>
<DefaultView
  viewPath={`${viewPath}/DefaultView`}
/>
<CompactViewNotes
  viewPath={`${viewPath}/CompactViewNotes`}
/>
<PaymentPlans
  viewPath={`${viewPath}/PaymentPlans`}
/>
</div>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--ml-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-1-Z1Yf8zk': typeof dtSpaceXxl === 'number' ? `${dtSpaceXxl}px` : dtSpaceXxl}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Treatment Fields"
/>
<CreateFieldAction
  viewPath={`${viewPath}/CreateFieldAction`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-4-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical1}`}
>
<DataVaxiomTxCardFieldDefinitionsList
  viewPath={`${viewPath}/DataVaxiomTxCardFieldDefinitionsList`}
 data="selected.location_id"
 location_id={selectedLocationIdValueData}
/>
</div>
{children}
</React.Fragment>)
}